import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import HeaderComponent from '../../HeaderComponent';
import LoadingComponent from '../../LoadingComponent';
import TradeTable from './TradeTable';
import TradeRow from './TradeRow';
import Modal from '../../Modal';
import LoadMore from '../../LoadMore';

import css from '../../../styles/instrument/trades/trades';

class Trades extends Component {
    static propTypes = {
        title: PropTypes.string,
        isLoading: PropTypes.bool,
        modalOpen: PropTypes.bool,
        openModal: PropTypes.func,
        closeModal: PropTypes.func,
        symbol: PropTypes.string,
        trades: PropTypes.array,
        requestTradeData: PropTypes.func,
        t: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.rows = 0;

        this._fetchMore = () => {
            this.props.requestTradeData(this.props.symbol, this.rows += 100);
        };

        this._openModal = () => {
            if (this.rows < 100) {
                this._fetchMore();
            }

            this.props.openModal('trades');
        };
    }

    renderTrades(limit) {
        const { trades } = this.props;

        const rows = limit ? trades.slice(0, limit) : trades;

        if (!limit) {
            this.rows = rows.length;
        }

        return rows.map(row => <TradeRow {...row} key={row.ID} />);
    }

    renderModal() {
        // @TODO: Hide button after fetching entire list.
        if (!this.props.modalOpen) return null;

        return (
            <Modal onClick={this.props.closeModal} title="Dagens handel" symbol={this.props.title}>
                <div className={css.modalWrapper}>
                    <TradeTable>
                        {this.renderTrades()}
                    </TradeTable>
                    <div className={css.loadWrapper}>
                        <LoadMore
                            onClick={this._fetchMore}
                            loading={this.props.isLoading}
                        />
                    </div>
                </div>
            </Modal>
        );
    }

    renderContent() {
        if (!this.props.trades.length) {
            return <LoadingComponent height={255} />;
        }

        return (
            <div>
                <div className={css.tableWrapper}>
                    <TradeTable>
                        {this.renderTrades(5)}
                    </TradeTable>
                </div>
                {this.renderModal()}
            </div>
        );
    }

    render() {
        // @TODO: Render disclaimer when market is closed (15 min delay)
        if (!this.props.isLoading && !this.props.trades.length) {
            return null;
        }

        const { t } = this.props;

        return (
            <HeaderComponent
                title={t('lastDeals.title')}
                onclick={this._openModal}
                label={t('lastDeals.todayDeals')}
            >
                {this.renderContent()}
            </HeaderComponent>
        );
    }
}

export default translate('stocks')(Trades);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/trades/Trades.js
 **/